/* Nub's Media v161: canonicalize release pages using validated Liquid release data.
   Shopify Liquid has no reliable query-parameter accessor in theme.liquid's
   head. Never treat a title-only URL as a canonical release identity. */
(() => {
  const ORIGIN = 'https://nubsmedia.ca';
  const RELEASE_PATH = /^\/community\/release\/[a-z0-9][a-z0-9-]*-nmrel-\d{6,12}$/;
  const META_PATH = /^(?:\/(?:fr|es))?\/pages\/media-release\/nmrel-\d{6,12}$/i;
  const PROXY_PATH = /^(?:\/(?:fr|es))?\/community\/release\/[^/]+$/i;

  function canonicalFromValidatedRelease() {
    const release = document.querySelector('.nubs-media-release[data-current-catalog-id][data-nubs-release-public-url]');
    if (!release) return null;
    const raw = String(release.dataset.nubsReleasePublicUrl || '').trim();
    const id = /^NMREL-(\d{6,12})$/i.exec(String(release.dataset.currentCatalogId || '').trim());
    if (!id || !raw || !raw.startsWith('/')) return null;
    let target;
    try { target = new URL(raw, ORIGIN); } catch (_) { return null; }
    if (target.origin !== ORIGIN || !RELEASE_PATH.test(target.pathname)) return null;
    if (!target.pathname.endsWith(`-nmrel-${id[1]}`) || target.search || target.hash) return null;
    return target;
  }

  function fix() {
    const current = new URL(window.location.href);
    if (!PROXY_PATH.test(current.pathname) && !META_PATH.test(current.pathname)) return;
    const canonical = canonicalFromValidatedRelease();
    if (!canonical) return; // A missing or unresolved ID must not be guessed from the slug.
    const verifiedId = /^NMREL-(\d{6,12})$/i.exec(String(document.querySelector('.nubs-media-release[data-current-catalog-id]')?.dataset.currentCatalogId || ''))?.[1];

    // The app-proxy Liquid title is not automatically propagated to Shopify's
    // outer <head>. Set the visible browser-tab title from the *validated*
    // release page after initial render and after soft navigation. This does
    // not replace server-rendered SEO metadata/canonical declarations.
    const releaseTitle = document.querySelector('.nubs-media-release__title')?.textContent?.trim().replace(/\s+/g, ' ');
    if (releaseTitle && releaseTitle.length <= 240) {
      const title = `${releaseTitle} | Nub's Media Database`;
      if (document.title !== title) document.title = title;
      // Preserve only the title actually read from a validated NMREL page.
      // A future reload can set it before first paint without a title lookup.
      try {
        if (verifiedId) sessionStorage.setItem(`nubs:verified-release-title:${verifiedId}`, JSON.stringify({
          path: canonical.pathname, title: releaseTitle, time: Date.now(),
        }));
      } catch (_) { /* Browsing must not depend on storage permission. */ }
      const og = document.querySelector('meta[property="og:title"]');
      if (og) {og.content = title;og.setAttribute('data-nubs-seo','');}
    }

    // HTML canonical is preferred when Shopify can read the native metaobject;
    // this is a strictly validated fallback for app-proxy pages.
    const links = [...document.querySelectorAll('link[rel~="canonical"]')];
    const link = links.shift() || document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('data-nubs-seo','');
    link.href = canonical.href;
    if (!link.isConnected) document.head.appendChild(link);
    for (const duplicate of links) duplicate.remove();
    const og = document.querySelector('meta[property="og:url"]') || document.createElement('meta');
    og.setAttribute('property', 'og:url');
    og.setAttribute('data-nubs-seo','');
    og.content = canonical.href;
    if (!og.isConnected) document.head.appendChild(og);

    // CSP-compatible successor to the old inline redirect on native Shopify
    // metaobject pages. Shopify must keep serving the underlying metaobject.
    if (META_PATH.test(current.pathname)) {
      // Preserve interface language for visitors; all variants still declare
      // the single English-path canonical for the untranslated release data.
      const locale = /^\/(fr|es)\//i.exec(current.pathname)?.[1]?.toLowerCase() || '';
      const localizedPath = `${locale ? `/${locale}` : ''}${canonical.pathname}`;
      window.location.replace(localizedPath + canonical.search + current.hash);
    }
    // For a valid id with an obsolete title slug, the canonical points to the
    // right slug; we don't rewrite browsing history behind the visitor's back.
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix, {once:true});
  else fix();
  document.addEventListener('nubs:pagechange', fix);
})();
